import styled from "@emotion/styled";
import { mainPadding } from "../../containers/main-container";
import media, { Breakpoint, Comp } from "../../libs/media-master";

interface Props {
  amountOfGames: number;
}

const GRID_GAP = mainPadding;
export const GAME_ITEM_SIZE = "8rem";
const COLUMN_LENGTH = 5;

const GameList = styled.div<Props>`
  display: grid;
  grid-gap: ${GRID_GAP};
  grid-template-columns: repeat(
    ${COLUMN_LENGTH},
    calc(
      (
          (${Breakpoint.TABLET}px - (2 * ${mainPadding})) -
            (${COLUMN_LENGTH - 1} * ${GRID_GAP})
        ) / ${COLUMN_LENGTH}
    )
  );
  grid-template-rows: repeat(
    ${(props) => Math.ceil(props.amountOfGames / COLUMN_LENGTH)},
    ${GAME_ITEM_SIZE}
  );
  margin: 1rem 0;

  ${media([Comp.SMALLER_THAN_OR_EQUAL, Breakpoint.TABLET])} {
    grid-template-columns: ${(props) =>
      `0 repeat(${props.amountOfGames}, ${GAME_ITEM_SIZE}) 1px;`};
    grid-template-rows: minmax(${GAME_ITEM_SIZE}, 1fr);
    margin: 1rem -${mainPadding} 0;
    overflow-x: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
    scroll-snap-type: x proximity;
    list-style: none;
    height: calc(${GAME_ITEM_SIZE} + 1rem);
    ::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    ::before {
      content: "";
    }
    ::after {
      content: "";
    }
  }
`;

export default GameList;
